<template>
  <a-drawer width="55%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form"  :rules="rules">
      <a-form-model-item prop="redPacketNum" >
        <span slot="label" >
        <a-tooltip>
        {{$t('红包金额')}}<template slot="title">{{$t('红包金额')}}</template>
        </a-tooltip>
        </span>
        <a-input type="number" v-model="form.redPacketNum" :max="99999" :min="1" :placeholder="$t('通用.输入.请输入')+$t('红包金额')"/>
      </a-form-model-item>
      <a-form-model-item prop="redPacketPeople" >
        <span slot="label" >
        <a-tooltip>
        {{$t('红包个数')}}<template slot="title">{{$t('红包个数')}}</template>
        </a-tooltip>
        </span>
        <a-input type="number" v-model="form.redPacketPeople" :max="99999" :min="1" :placeholder="$t('通用.输入.请输入')+$t('红包个数')"/>
      </a-form-model-item>
      <a-form-model-item prop="redPacketValid" >
        <span slot="label" >
        <a-tooltip>
        {{$t('红包开奖时间（秒）')}}<template slot="title">{{$t('红包开奖时间（秒）')}}</template>
        </a-tooltip>
        </span>
        <a-input type="number" v-model="form.redPacketValid" :max="99999" :min="1" :placeholder="$t('通用.输入.请输入')+$t('红包开奖时间')"/>
      </a-form-model-item>

      <a-form-model-item prop="liveRedExpire" >
        <span slot="label" >
        <a-tooltip>
        {{$t('红包开奖后过期时间')}}<template slot="title">{{$t('红包开奖后过期时间')}}</template>
        </a-tooltip>
        </span>
        <a-input type="number" v-model="form.liveRedExpire" :max="99999" :min="1" :placeholder="$t('通用.输入.请输入')+$t('红包开奖时间')"/>
      </a-form-model-item>









      <a-form-model-item prop="redMode" >
            <span slot="label" >
              <a-tooltip>
                {{$t('红包类型')}}<template slot="title">{{$t('红包类型')}}</template>
              </a-tooltip>
            </span>
        <a-select v-model="form.redMode" placeholder="请选择类型">
          <a-select-option v-for="(item, index) in redModeList" :value="item.value" :key="index">
            {{ item.label}}
          </a-select-option>
        </a-select>
      </a-form-model-item>

      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{$t('通用.按钮.保存')}}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{$t('通用.按钮.取消')}}
          </a-button>
        </a-space>
      </div>

    </a-form-model>
  </a-drawer>
</template>

<script>
import {getLive, addLive, updateLive, shopUserList, userList, addRedPacket} from '@/api/live/live'
import {mapGetters} from 'vuex'
import CustomDictTag from "@/components/DictCustomTag";
import {generateFilePath, uploadObject, uploadOss} from "@/api/tool/oss";

//选择商品
import RadioGoodsSelectForm from "@/views/live/live/modules/GoodsSelectForm";
import {allBrand} from "@/api/goods/brand";
//选择商品

export default {
  name: 'CreateFormRedPacket',
  props: {
  },
  components: {
    CustomDictTag,
    //选择商品
    RadioGoodsSelectForm
    //选择商品
  },
  data () {
    return {
      shopUserList:[],
      redModeList:[
          {
            value: 0,
            label: this.$t('均衡')
          },
        {
          value: 1,
          label: this.$t('随机')
        },
      ],
      signList:[
        {
          value: 0,
          label: this.$t('否')
        },
        {
          value: 1,
          label: this.$t('是')
        },

      ],
        userList:[],
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      previewImageVisible: false,
      previewUrl: '',
      previewVideoVisible: false,
      loading: '',

      //选择商品
      categoryList:[],
      goodsColumns: [
        /*{
          title: this.$t('商品.商品编号'),
          dataIndex: 'goodsCode',
          width: 100,
          fixed: 'left',
        },*/
        {
          title: this.$t('商品.商品名称'),
          dataIndex: 'goodsName',
          width: 180,
          fixed: 'left',
        },
        {
          title: this.$t('商品.商品主图'),
          dataIndex: 'picture',
          width: 60,
          scopedSlots: {customRender: 'picture'},
        },
        {
          title: this.$t('商品.商品分类'),
          dataIndex: 'categoryId',
          width: 60,
          scopedSlots: {customRender: 'categoryId'},
        },
        {
          title: this.$t('商品.品牌'),
          dataIndex: 'brandId',
          width: 50,
          scopedSlots: {customRender: 'brandId'},
        },
        // {
        //   title: this.$t('商品.市场价'),
        //   width: 50,
        //   dataIndex: 'marketPrice',
        // },
        {
          title: this.$t('商品.商品价'),
          width: 50,
          dataIndex: 'price',
        },
      ],
      //选择商品

      // 表单参数
      form: {

        id: null,
        redPacketNum: null,
        redPacketPeople: null,
        redPacketValid: null,
        liveRedExpire: null,
        liveId: null,
        groupChatId: null,
        redMode: 0,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        liveScreen:[
          { required: true, message: this.$t('直播主题')+this.$t('通用.输入.请选择'), trigger: 'blur' }
        ] ,redPacketNum:[
          { required: true, message: this.$t('红包金额')+this.$t('通用.输入.不能为空'), trigger: 'blur' }
        ],
        redPacketPeople:[
          { required: true, message: this.$t('红包数量')+this.$t('通用.输入.不能为空'), trigger: 'blur' }
        ], redPacketValid:[
          { required: true, message: this.$t('红包开奖时间')+this.$t('通用.输入.不能为空'), trigger: 'blur' }
        ], liveRedExpire:[
          { required: true, message: this.$t('开奖后有效时间')+this.$t('通用.输入.不能为空'), trigger: 'blur' }
        ],
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    previewImageCancel() {
      this.previewImageVisible = false;
    },
    previewVideoCancel() {
      this.previewVideoVisible = false;
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        //选择商品
        goodsList: [],
        //选择商品
        id: null,
        redPacketNum: null,
        redPacketPeople: null,
        redPacketValid: null,
        liveRedExpire: null,
        liveId: null,
        redMode: 0,
      }

    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('发红包')
      this.liveId=row.id
      this.form.groupChatId=row.id
        console.log( 1111,row)
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      //查询店铺用户
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getLive({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('通用.文本.修改')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = '';
            message = this.$t('发红包成功')
            addRedPacket(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
        } else {
          return false
        }
      })
    },
    limitPrice() {
      // console.log(i);
      let val = this.form.signScore.replace(/^\D*([0-9]\d*\.?\d{0,2})?.*$/, '$1');
      if (val == null || val == undefined || val == '' || val < 0) {
        val = ''
      }
      if (val > 21474836) {
        val = 21474836
      }
      this.form.signScore = val
    },
    limitPrice1() {
      // console.log(i);
      let val = this.form.seekScore.replace(/^\D*([0-9]\d*\.?\d{0,2})?.*$/, '$1');
      if (val == null || val == undefined || val == '' || val < 0) {
        val = ''
      }
      if (val > 21474836) {
        val = 21474836
      }
      this.form.seekScore = val
    },

    limitbitRate() {
      // console.log(i);
      let val = this.form.bitRate.replace(/^\D*([0-9]\d*\.?\d{0,2})?.*$/, '$1');
      if (val == null || val == undefined || val == '' || val < 0) {
        val = ''
      }
      if (val > 21474836) {
        val = 21474836
      }
      this.form.bitRate = val
    },







  }
}
</script>
